import { Trans, useTranslation, type TransProps } from 'react-i18next';

function MyTrans(props: TransProps<any>) {
  useTranslation();
  return <Trans {...props}></Trans>;
}

export { MyTrans };
